import React, { useState, useEffect } from 'react';
import Moment from 'moment';
import PropTypes from 'prop-types';
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  CircularProgress,
  IconButton,
} from '@material-ui/core';
import RemoveRedEyeIcon from '@material-ui/icons/RemoveRedEye';
import { withStyles } from '@material-ui/core/styles';
import { useSnackbar } from 'notistack';
import ApptReqPreviewModal from './ApptReqPreviewModal';
import ApptRequestAttachmentModal from './ApptRequestAttachmentModal';
import { fetchPatientReferrals } from '../services/api';
import * as portalApi from '../services/api/portal';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import AttachmentIcon from '@material-ui/icons/Attachment';

function PatientChartApptReqs(props) {
  const {
    patientId,
    classes: { loading, modal, modalContent, customSpacing },
  } = props;

  const enqueueSnackbar = useSnackbar();
  const pageLimit = 10;

  const [isLoading, setIsLoading] = useState(false);
  const [apptReqs, setApptReqs] = useState([]);
  const [inspectedReq, setInspectedReq] = useState(null);
  const [pageIndex, setPageIndex] = useState(0);
  const [attachment, setAttachment] = useState(null);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      try {
        await patientRequestReferrals();
        // const newWayRequests = await fetchPatientReferrals(patientId);
        // const oldWayRequests = await portalApi.getPatientAppointmentRequests(patientId);

        // //keeping the "by" key so that the field value is handled before the two different data structures
        // //become one - as you can see, the newWayReqs' by field should always be the fromProvider name,
        // //but the ogWayReqs' by field should be the sender's name or, if empty, just PATIENT.
        // setApptReqs([
        //   ...newWayRequests.map(ref => ({
        //     id: ref.id,
        //     body: ref.body,
        //     fromProvider: ref.fromProvider,
        //     toProvider: ref.toProvider,
        //     patient: ref.patient,
        //     time: ref.createdAt,
        //     by: ref.fromProvider.name,
        //   })),
        //   ...oldWayRequests.map(req => {
        //     let body;
        //     if (req.visitReason && req.portalNotes) {
        //       body = `${req.visitReason}\n=${req.portalNotes}`;
        //     }
        //     else {
        //       body = req.visitReason || req.portalNotes || '';
        //     }
        //     return {
        //       id: req.id,
        //       body,
        //       fromProvider: req.sender,
        //       patient: req.patient,
        //       toProvider: req.receiver,
        //       time: req.createdAt,
        //       by: req.sender.name || 'PATIENT'
        //     }
        //   })
        // ]);
      } catch (err) {
        enqueueSnackbar("Unable to fetch patient's requests and referrals");
      }
      setIsLoading(false);
    })();
  }, []);

  const patientRequestReferrals = async () => {
    const newWayRequests = await fetchPatientReferrals(patientId);
    const oldWayRequests = await portalApi.getPatientAppointmentRequests(
      patientId
    );
    //keeping the "by" key so that the field value is handled before the two different data structures
    //become one - as you can see, the newWayReqs' by field should always be the fromProvider name,
    //but the ogWayReqs' by field should be the sender's name or, if empty, just PATIENT.
    setApptReqs([
      ...newWayRequests.map(ref => ({
        id: ref.id,
        body: ref.body,
        fromProvider: ref.fromProvider,
        toProvider: ref.toProvider,
        patient: ref.patient,
        time: ref.createdAt,
        by: ref.fromProvider.name,
        isAttachment: ref.isAttachment,
      })),
      ...oldWayRequests.map(req => {
        let body;
        if (req.visitReason && req.portalNotes) {
          body = `${req.visitReason}\n=${req.portalNotes}`;
        } else {
          body = req.visitReason || req.portalNotes || '';
        }
        return {
          id: req.id,
          body,
          fromProvider: req.sender,
          patient: req.patient,
          toProvider: req.receiver,
          time: req.createdAt,
          by: req.sender.name || 'PATIENT',
          isAttachment: req.isAttachment,
        };
      }),
    ]);
    setIsLoading(false);
  };

  const onPageBack = async () => {
    if (pageIndex === 0) {
      enqueueSnackbar('You are on the first page');
    } else {
      setPageIndex(pageIndex - 1);
    }
  };

  const onPageForward = async () => {
    setPageIndex(pageIndex + 1);
  };

  return isLoading ? (
    <div className={loading}>
      <CircularProgress />
    </div>
  ) : (
    <>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Doc</TableCell>
            <TableCell>Requested at time</TableCell>
            <TableCell>Requested by</TableCell>
            <TableCell>View Message</TableCell>
            <TableCell>Attachments</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {apptReqs
            .sort((a1, a2) => (Moment(a1.time).isAfter(a2.time) ? -1 : 1))
            .map(apptReq => (
              <TableRow key={apptReq.id}>
                <TableCell>{apptReq.toProvider.name}</TableCell>
                <TableCell>
                  {Moment(apptReq.time).format('h:mm a - MM/DD/YYYY')}
                </TableCell>
                <TableCell>{apptReq.by}</TableCell>
                <TableCell>
                  <IconButton onClick={() => setInspectedReq(apptReq)}>
                    <RemoveRedEyeIcon />
                  </IconButton>
                </TableCell>
                <TableCell>
                  {apptReq.isAttachment ? (
                    <IconButton
                      title={apptReq.isAttachment ? 'View Attachment' : null}
                    >
                      <AttachmentIcon onClick={() => setAttachment(apptReq)} />
                    </IconButton>
                  ) : (
                    <span className={props.classes.customSpacing}>-</span>
                  )}
                  {/* <IconButton
                    title={apptReq.isAttachment ? "View Attachment" :"No Attachment Found"}
                  >

             {apptReq.isAttachment ? <AttachmentIcon onClick={() => setAttachment(apptReq)} /> :
              '-' } 
                  </IconButton> */}
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
      {inspectedReq && (
        <ApptReqPreviewModal
          onClose={() => setInspectedReq(null)}
          appointment={inspectedReq}
          viewOnly={true}
        />
      )}
      {attachment && (
        <ApptRequestAttachmentModal
          onClose={() => setAttachment(null)}
          appointment={attachment}
          viewOnly={true}
        />
      )}
      {/* <div className={props.classes.pageTurners}>
          <IconButton disabled={pageIndex === 0}>
            <ArrowBackIosIcon
              style={{ opacity: pageIndex === 0 ? '0.5' : '1.0' }}
              color="primary"
              variant="contained"
              onClick={onPageBack}
            />
          </IconButton>
          <IconButton >
            <ArrowForwardIosIcon
              style={{ opacity: apptReqs.length < pageLimit ? '0.5' : '1.0' }}
              color="primary"
              variant="contained"
              onClick={onPageForward}
            />
          </IconButton>
        </div> */}
    </>
  );
}

PatientChartApptReqs.propTypes = {
  patient: PropTypes.object,
};

const styles = () => ({
  loading: {
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  pageTurners: {
    width: '100%',
    marginTop: '5px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  customSpacing: {
    marginLeft: '21px',
    display: 'block',
  },
});

export default withStyles(styles)(PatientChartApptReqs);
